import React from "react";
import styled from "styled-components";
import { keyframes } from "styled-components";
import loaderLogo from "../images/loaderLogo.svg";

const Wrapper = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-image: url(${loaderLogo});
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const Loader = styled.div`
  box-sizing: border-box;
  border: 6px solid white;
  border-radius: 50%;
  border-top: 6px solid #f2c94c;
  width: 150px;
  height: 150px;

  -webkit-animation: ${spin} 2s linear infinite; /* Safari */
  animation: ${spin} 2s linear infinite;
`;

export const renderLoader = () => {
  return (
    <Wrapper>
      <Loader />
    </Wrapper>
  );
};
